<template>
    <content-layout>
        <h1 slot="header"></h1>

        <div class="file-filter-container">
            <div class="row">
                <div class="small-6 medium-4 large-2 colum"></div>
                <div class="small-6 medium-8 large-10 column">
                    <material-filter :current.sync="sort"></material-filter>
                </div>
            </div>
        </div>

        <div>
            <div class="row">
                <div class="small-6 medium-4 large-2 colum sidebar">
                    <spinner v-if="loadingUser === true" class="spinner"></spinner>
                    <div v-else-if="user" class="profile-details">
                        <div>
                            <img v-if="user.avatar" :src="user.avatar.sizes.icon.full_url" class="avatar"/>
                            <svg-icon v-else :symbol="avatarIcon" class="avatar"></svg-icon>
                            <h4 class="name">{{ user.name }}</h4>
                            <p class="school" v-if="user.school">{{ user.school.title }}</p>
                            <p class="description">{{ user.description }}</p>
                        </div>

                        <div>
                            <h4>Kopējā statistika</h4>
                            <ul class="profile-stats">
                                <li class="with-icon"><svg-icon :symbol="likeIcon" :original-dims="true"></svg-icon>Patīk: {{ statistics.likes }}</li>
                                <li class="with-icon"><svg-icon :symbol="viewIcon" :original-dims="true"></svg-icon>Skatījumi: {{ statistics.views }}</li>
                                <li class="with-icon"><svg-icon :symbol="downloadIcon" :original-dims="true"></svg-icon>Lejuplādes: {{ statistics.downloads }}</li>
                            </ul>
                        </div>
                        <div>
                            <a href="#" class="link" @click.prevent="" v-open-in-reveal="{ component: messageReveal, props: { recipient: user }}">
                                <svg-icon :symbol="messageIcon" :original-dims="true"></svg-icon> Sūtīt ziņu
                            </a>
                        </div>
                    </div>
                </div>
                <div class="small-6 medium-8 large-10 column content">
                    <h4 class="breadcrumb" v-if="categoryNode">
                        <span class="crumb"><router-link :to="{ name: 'profiles', params: { id: user.id } }">{{ user.name }}</router-link></span>
                        <span class="crumb" v-for="p in categoryNode.path">
                            <router-link :to="{ name: 'profiles.categories', params: { id: user.id, categoryNodeId: p.id } }" :key="p.id">{{p.category.title}}</router-link>
                        </span>
                        <span class="crumb">{{ categoryNode.category.title }}</span>
                    </h4>

                    <!--<h4>Manu materiālu sadalījums</h4>-->
                    <div class="row small-up-1 medium-up-2 large-up-4">
                        <spinner v-if="loadingCategories === true" class="spinner"></spinner>
                        <div v-else class="column" v-for="node in categories" :key="node.id">
                            <category-title-item v-if="node.parent_id === null"
                                                 :title="node.category.title"
                                                 :children-count="node.category.user_materials_count"
                                                 :link-to="{ name: 'profiles.categories', params: { id: user.id, categoryNodeId: node.id } }"></category-title-item>
                            <category-item v-else
                                    :linkTo="{ name: 'profiles.categories', params: { id: user.id, categoryNodeId: node.id } }"
                                    :title="node.category.title"
                                    :icon="node.category.icon_url"
                                    :count="node.category.user_materials_count"></category-item>
                        </div>
                    </div>

                    <hr v-if="categories.length > 0"/>

                    <div class="file-list-container row small-up-1 medium-up-2 large-up-4">
                        <spinner v-if="loading === true" class="spinner"></spinner>
                        <template v-else="">
                            <div class="column" v-for="material in materials" :key="material.id">
                                <material-item :material="material"></material-item>
                            </div>
                        </template>
                    </div>

                    <div class="pagination-container">
                        <pagination :current.sync="page" :total="pages"></pagination>
                    </div>

                </div>
            </div>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../layouts/ContentLayout'
    import MaterialItem from '../components/MaterialItem'
    import MaterialFilter from '../components/MaterialFilter'
    import SvgIcon from '../components/SvgIcon'
    import Pagination from '../components/common/Pagination'
    import OpenInReveal from '../directives/OpenInReveal'
    import CategoryTitleItem from '../components/CategoryTitleItem'
    import CategoryItem from "../components/CategoryItem"

    import likeIcon from '../../icons/icon-like.svg-sprite'
    import viewIcon from '../../icons/icon-view.svg-sprite'
    import downloadIcon from '../../icons/icon-download.svg-sprite'
    import avatarIcon from '../../icons/icon-avatar.svg-sprite'
    import messageIcon from '../../icons/icon-message.svg-sprite'

    import materials from '../api/materials'
    import users from '../api/users'
    import categories from '../api/categories'


    export default {

        created() {
            console.log('created with ', this.categoryNodeId);

            if (this.id !== this.user.id) {
                this.getUser().then(response => {
                    if (this.categoryNodeId === null) {
                        this.getCategoriesWithCount();
                        this.getMaterials();
                    } else {
                        this.getCategoryNode();
                    }
                });
            }
        },

        props: {
            'id': {
                type: [String, Number],
                required: true,
                default: null,
            },

            'categoryNodeId': {
                type: [String, Number],
                required: false,
                default: null,
            }
        },

        data() {
            return {
                likeIcon,
                viewIcon,
                downloadIcon,
                avatarIcon,
                messageIcon,

                messageReveal: require('../components/inbox/MessageReveal'),

                user: {
                    id: null,
                    name: null,
                    school: null,
                    description: null,
                    school_id: null,
                    avatar: null,
                    avatar_id: null
                },

                statistics: {
                    likes: 0,
                    views: 0,
                    downloads: 0
                },

                materials: [],
                categories: [],
                categoryNode: null,
                sort: 'created_at',
                page: 1,
                pages: 1,
                loading: false,
                loadingUser: false,
                loadingCategories: false
            }
        },

        methods: {

            getUser() {
                this.loadingUser = true;
                return users.find(this.id)
                    .then(response => {
                        Object.assign(this.user, response.data)
                        this.loadingUser = false;
                        return response;
                    });
            },

            /**
             * Get User materials or bookmarks.
             */
            getMaterials() {
                let cats = null;
                if (this.categoryNode) {
                    cats = this.categoryNode.path.map(function (cat) {return cat.category_id;});
                    cats.push(this.categoryNode.category_id);
                }

                this.loading = true;
                return materials.get({ sort: this.sort, page: this.page, owner: this.user.id, categories: cats })
                    .then(response => {
                        this.setMaterial(response.data)
                        this.loading = false;
                        return response;
                    })
            },

            /**
             * Set materials from API response data
             *
             * @param {Array} data
             * @param {Object} meta
             */
            setMaterial({ data, meta }) {
                this.materials = data;
                this.pages = meta ? meta.last_page : 1;
                this.page = meta ? meta.current_page : 1;
            },

            /**
             * Get User statistics
             */
            getStatistics() {
                users.statistics(this.user.id).then(response => {
                    this.statistics = response.data;
                })
            },

            getCategoriesWithCount() {
                this.loadingCategories = true;
                categories.get({ depth: 0, with_user_item_count: this.user.id, parent_id: this.categoryNodeId})
                    .then(response => {
                        this.categories = response.data;
                        this.loadingCategories = false;
                    })
            },

            getCategoryNode() {
                return categories.find(this.categoryNodeId)
                    .then(response => {
                        this.categoryNode = response.data;
                        return response;
                    })
            },

            /**
             * Reset component data
             */
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))
            }
        },

        watch: {
            /**
             *
             * @param {Number} val
             * @param {Number} oldVal
             */
            'id': function (val, oldVal) {
                if (typeof val === 'undefined' || val === null) {
                    this.reset();
                } else if (val !== oldVal) {
                    this.getUser(val)
                }
            },

            'user.id': function (val, oldVal) {
                this.getStatistics();

                if (this.categoryNodeId === null) {
                    this.getMaterials();
                    this.getCategoriesWithCount();
                } else {
                    this.getCategoryNode();
                }

            },

            categoryNodeId: function (val, oldVal) {
                if (val) {
                    this.getCategoryNode();
                } else {
                    this.categoryNode = null;
                }
            },

            categoryNode: function (val, oldVal) {
                this.getCategoriesWithCount()
                this.getMaterials();
            },

            /**
             *
             * @param {String} val
             * @param {String} oldVal
             */
            sort: function (val, oldVal) {
                console.log('sort changed', val, oldVal);
                if (typeof val !== 'undefined' && val !== null  && val !== oldVal) {
                    this.getMaterials();
                }
            },

            /**
             *
             * @param val
             * @param oldVal
             */
            page: function (val, oldVal) {
                console.log('page changed', val, oldVal);
                if (typeof val !== 'undefined' && val !== null  && val !== oldVal) {
                    this.getMaterials();
                }
            }
        },

        components: {
            MaterialItem, MaterialFilter, ContentLayout, SvgIcon, Pagination, CategoryTitleItem, CategoryItem
        },

        directives: {
            OpenInReveal
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .profile-details {
        font-size: 12px/16px + rem;

        .avatar {
            width: 84px;
            height: auto;
            &svg {
                height: 84px;
            }
            display: block;
            margin-bottom: 2em;
        }

        p {
            margin: 0;
        }

        h4 {
            font-weight: 700;
            margin-bottom: 0;
            font-size: px-em(14px, 12px);
        }

        .description {
            margin-top: 2em;
        }

        > *:not(:last-child) {
            margin-bottom: 2em;
        }
    }

    .file-filter-container {
        background-color: white;
    }

    .tag {
        color: white;
        font-size: 14px;
        font-weight: 700;
        background-color: #7b7979;
        position: relative;
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 1em;
        display: inline-block;
        white-space: nowrap;

        &:after {
            content: "";
            position: absolute;
            right: -30px;
            border: 15px solid transparent;
            border-left-color: #7b7979;
        }
    }

    .profile-nav {
        @include reset-list();
        margin-bottom: 2em;

        > li {
            margin-bottom: 0.75em;
        }

        > li > a {
            color: inherit;
            font-weight: 700;
            font-size: px-em(13px, 12px);
            padding-left: 20px;//Compensate inline icon

            &:hover,
            &:active {
                text-decoration: underline;
            }
        }

        svg {
            fill: #404141;
        }
    }

    .profile-stats {
        @include reset-list();

        svg {
            fill: #999999;
        }
    }

    .sidebar,
    .content {
        padding-top:  2rem;
    }

    //TODO duplicate
    .file-list-container {
        padding-bottom: 1.875rem;
    }

    //TODO duplicate
    .pagination-container {
        text-align: center;
    }

    //TODO create breadcrumb
    .breadcrumb {
        margin-bottom: 2rem;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Profile.vue